import { EMR_APIS } from "@/api_framework/api_config";
import { IEMRStaticUnitsResponse, IEMRStaticUnitsResponseData } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export const useStaticUnitsAPI = () => {
  const [data, setData] = useState<IEMRStaticUnitsResponseData[]>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response: IEMRStaticUnitsResponseData[] = await axios
        .get(EMR_APIS?.STATIC_UNITS?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IEMRStaticUnitsResponse>) => {
          if (res.data.status === true) {
            setData(res.data.data);
            return res.data.data;
          } else {
            setData(null);
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          setData(null);
          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return { data, execute };
};
